import type { DeepPartial } from "../../../../core/utils/DeepPartial.js";
import type { Cart, CartFieldsForStep, CartInStep } from "../../stores/cart/Cart.js";
import { type CartStep, cartStepOrderMap } from "../../stores/cart/CartStep.js";
import { cartStore } from "../../stores/cart/cartStore.js";

/*
 * If the cart is further in the process, we don't want to let the user save the form if it is invalid.
 * This is because the user would be able to have unfilled required fields in the cart from previous steps.
 * @returns Whether the form was saved.
 */
export async function trySaveCartFields<CurrentStep extends CartStep, StepInCart extends CartStep>(
	form: HTMLFormElement,
	currentStep: CurrentStep,
	cart: CartInStep<StepInCart>,
	fields: DeepPartial<CartFieldsForStep<CurrentStep>>,
): Promise<boolean> {
	const cartStepIndex = cartStepOrderMap[cart.step];
	const currentStepIndex = cartStepOrderMap[currentStep];
	if (cartStepIndex > currentStepIndex && !form.checkValidity()) {
		return false;
	}

	await cartStore.saveFields(fields as DeepPartial<Cart["order"]>);

	return true;
}
